import React, { FC } from "react";
import { useLabels } from "../Hooks/useLabels";
import { InformationCard } from "./InformationCard";
import { DoctorDto } from "@apiModels/DoctorDto.csharp";

interface InformationCardWithFiltersResetProps {
  doctor: DoctorDto;
  onResetFilters: () => void;
}

export const InformationCardWithFilterDoctors: FC<
  InformationCardWithFiltersResetProps
> = ({ doctor, onResetFilters }) => {
  const { bookingLabels } = useLabels();

  const isDoctorSelected = doctor.id && doctor.id !== "-1";

  const defaultHeader = `Viser tjenester $doctorName tilbyr`;
  const defaultDescription =
    "Derfor kan det vises få valg. $clearLink om du vil se alle tjenestene Volvat tilbyr.";
  const defaultClearLinkLabel = "Klikk her";

  const replaceDoctorPlaceholder = (label: string) =>
    label.replace("$doctorName", doctor.name);

  const getHeader = () => {
    if (!isDoctorSelected) return "";
    return replaceDoctorPlaceholder(
      bookingLabels?.stepsBookingLabels.newBookingStepsLabels
        .doctorFilterInformationText || defaultHeader
    );
  };

  const getClearLinkLabel = () =>
    bookingLabels?.stepsBookingLabels.newBookingStepsLabels
      .doctorFilterInformationClearLinkLabel || defaultClearLinkLabel;

  const getDescriptionParts = () => {
    if (!isDoctorSelected) return [];
    const label =
      bookingLabels?.stepsBookingLabels.newBookingStepsLabels
        .doctorFilterInformationDescription || defaultDescription;
    return replaceDoctorPlaceholder(label).split("$clearLink");
  };

  const renderDescription = () => {
    const parts = getDescriptionParts();
    if (parts.length === 0) return null;
    if (parts.length === 1) return <>{parts[0]}</>;
    return (
      <>
        {parts[0]}
        <button type="button" onClick={onResetFilters}>
          {getClearLinkLabel()}
        </button>
        {parts[1]}
      </>
    );
  };

  return (
    <InformationCard heading={getHeader()} description={renderDescription()} />
  );
};
